import Flex from "components/grid/Flex";
import { useTranslation } from "react-i18next";
import DateAndValue from "./DateAndValue";
import { getContentFullArray } from "./SimpleArrayOfValues";

const DateAndValueArray = ({ contentFullArray, array, translationKey, getValue, yearOnly, suffix }) => {
    const { t } = useTranslation();
    return (
        <Flex item container column>
            {(contentFullArray || getContentFullArray(array))?.map((rows, index) => {
                const date = rows.find((cell) => cell.question === "date")?.answer;
                const value = getValue
                    ? getValue(rows, index)
                    : translationKey
                      ? t(`${translationKey}.${rows.find((cell) => cell.question === "value")?.answer}`)
                      : rows.find((cell) => cell.question === "value")?.answer;
                return <DateAndValue key={date + value + index} {...{ date, value, yearOnly, suffix }} />;
            })}
        </Flex>
    );
};

export default DateAndValueArray;
